import { useState } from "react";
import Slider from 'react-slick';
import CollectionCard from "../../../components/CollectionCard/CollectionCard";
import { collections } from "../../../data/collections";


const PopularCollections = () => {

    const [popularFilter, setPopularFilter] = useState(['active', '', '', '']);

    const changePopularFilter = (index) => {
        let temparr = ['', '', '', ''];
        temparr[index] = 'active';
        setPopularFilter(temparr);
      }

    const sliderSettings = {
        dots: false,
        className: "center",
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
          {
            breakpoint: 1450,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
            {
              breakpoint: 1114,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                }
            },
        ]
    };


    return(
        <div>
          <div className="flex flex-col sm:flex-row mb-10 items-start sm:items-center">
            <h1 className='mr-5 mb-5 sm:mb-0 secondary_heading leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
              Top Collections
            </h1>
            <div className="flex border-gray-300 dark:border-gray-700 border-[1px] rounded-[20px]">
              <button className={`py-1 sm:py-2 px-2 sm:px-4 text-[10px] sm:text-[12px] rounded-[20px] w-[55px] sm:w-[80px] ${popularFilter[0] === 'active' && 'text-white bg-[#DE00FF]'}`} onClick = {()=>changePopularFilter(0)}>24 hrs</button>
              <button className={`py-1 sm:py-2 px-2 sm:px-4 text-[10px] sm:text-[12px] rounded-[20px] w-[55px] sm:w-[80px] ${popularFilter[1] === 'active' && 'text-white bg-[#DE00FF]'}`} onClick = {()=>changePopularFilter(1)}>7 days</button>
              <button className={`py-1 sm:py-2 px-2 sm:px-4 text-[10px] sm:text-[12px] rounded-[20px] w-[55px] sm:w-[80px] ${popularFilter[2] === 'active' && 'text-white bg-[#DE00FF]'}`} onClick = {()=>changePopularFilter(2)}>30 days</button>
              <button className={` py-1 sm:py-2 px-2 sm:px-4 text-[10px] sm:text-[12px] rounded-[20px] w-[55px] sm:w-[80px] ${popularFilter[3] === 'active' && 'text-white bg-[#DE00FF]'}`} onClick = {()=>changePopularFilter(3)}>All time</button>
            </div>
          </div>
          <Slider {...sliderSettings}>
            {collections.map((collection, index) => {
              if(index < 6){
                return (
                  <CollectionCard item={collection} className='px-5'/>
                )
              }
              else{
                return null;
              }
            })}
          </Slider>

        </div>
    )
}

export default PopularCollections;